// helpers
import {formatCurrency} from '../../../../helpers';

// types
import {TFunction} from 'i18next';
import {Subscription} from '../../../../services/ApiService/types';

/**
 * Get the summary fields for subscription details
 * @param subscriptionSummary
 * @param t
 */
export const getSummaryFields = (
  subscriptionSummary: Subscription,
  t: TFunction,
) => {
  return [
    {
      label: t('global_status'),
      content: subscriptionSummary.status,
    },
    {
      label: t('subscription_amount'),
      content: formatCurrency(subscriptionSummary.amount),
    },
    {
      label: t('global_paymentFrequency'),
      content: subscriptionSummary.paymentFrequency.toString(),
    },
    {
      label: t('global_numberOfPayments'),
      content: subscriptionSummary.numberOfPayments.toString(),
    },
    {
      label: t('global_totalOwing'),
      content: formatCurrency(subscriptionSummary.totalOwing),
    },
    {
      label: t('global_creationDate'),
      content: subscriptionSummary.startDate,
    },
  ];
};
